import { render, staticRenderFns } from "./TypesConfiguration.vue?vue&type=template&id=4ccb7fec&scoped=true"
import script from "./TypesConfiguration.vue?vue&type=script&lang=ts"
export * from "./TypesConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./TypesConfiguration.vue?vue&type=style&index=0&id=4ccb7fec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb7fec",
  null
  
)

export default component.exports